import { createContext } from 'react';

var SupportedLanguages;
(function(SupportedLanguages) {
    SupportedLanguages["Bash"] = "bash";
    SupportedLanguages["Go"] = "go";
    SupportedLanguages["Java"] = "java";
    SupportedLanguages["JavaScript"] = "javascript";
    SupportedLanguages["JSON"] = "json";
    SupportedLanguages["JSX"] = "jsx";
    SupportedLanguages["Kotlin"] = "kotlin";
    SupportedLanguages["Node"] = "node";
    SupportedLanguages["PHP"] = "php";
    SupportedLanguages["Python"] = "python";
    SupportedLanguages["Ruby"] = "ruby";
    SupportedLanguages["Shell"] = "shell";
    SupportedLanguages["Swift"] = "swift";
    SupportedLanguages["TSX"] = "tsx";
    SupportedLanguages["TypeScript"] = "typescript";
})(SupportedLanguages || (SupportedLanguages = {}));
// Internal mapping from SupportedLanguages to valid Prism languages
const PrismLanguageMapping = {
    // Direct mappings (supported by react-prism-renderer)
    [SupportedLanguages.Bash]: 'bash',
    [SupportedLanguages.Go]: 'go',
    [SupportedLanguages.JavaScript]: 'javascript',
    [SupportedLanguages.JSON]: 'json',
    [SupportedLanguages.JSX]: 'jsx',
    [SupportedLanguages.Kotlin]: 'kotlin',
    [SupportedLanguages.Python]: 'python',
    [SupportedLanguages.Swift]: 'swift',
    [SupportedLanguages.TSX]: 'tsx',
    [SupportedLanguages.TypeScript]: 'typescript',
    // Mapped languages (fallback to similar languages)
    [SupportedLanguages.Java]: 'kotlin',
    [SupportedLanguages.Node]: 'javascript',
    [SupportedLanguages.PHP]: 'json',
    [SupportedLanguages.Ruby]: 'python',
    [SupportedLanguages.Shell]: 'bash'
};
/**
 * CodeSnippet Context.
 */ const CodeSnippetContext = /*#__PURE__*/ createContext(null);

export { CodeSnippetContext, PrismLanguageMapping, SupportedLanguages };
//# sourceMappingURL=context.es.js.map
